import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Showreel } from "@/components/Showreel";
import { Contact } from "@/components/Contact";
import brandLogo from "@/logo_full_light.png";

const Loader = () => (
  <motion.div
    initial={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5 }}
    className="fixed inset-0 z-[100] bg-brand-dark flex items-center justify-center px-8"
    data-testid="loader"
  >
    <motion.img
      src={brandLogo}
      alt="New Graphic"
      initial={{ opacity: 0, scale: 0.9, y: 10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="w-[min(70vw,520px)] h-auto"
    />
  </motion.div>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const timer = setTimeout(() => setLoading(false), 1300);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="bg-brand-dark min-h-screen">
      <div className="grain" />
      <AnimatePresence>{loading && <Loader />}</AnimatePresence>
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Manifesto />
        <Showreel />
        <Contact />
      </main>
    </div>
  );
}

export default App;
